/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
    Select,
    MenuItem,
    AppBar,
    Toolbar,
    Typography,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormLabel,
    Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import styled from "@emotion/styled";
import RetrunFindCoupon from './ReturnFindCoupon';
import get_token from "../lib/get_token";
import LightbulbIcon from "@mui/icons-material/Lightbulb";


const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const columns = [
    { field: "id", headerName: "id", hide: true },
    {
        field: "regdate",
        headerName: "등록",
        width: 110,
        align: "center",
        renderCell: (params) => {
            return moment(params.row.regdate).format("YYYY.MM.DD");
        },
    },
    {
        field: "mb_name",
        headerName: "이름",
        width: 110,
        align: "center",
    },
    {
        field: "mb_phone_format",
        headerName: "연락처",
        width: 110,
        align: "center",
    },
    {
        field: "gubun",
        headerName: "구분",
        width: 90,
        align: "center",
        renderCell: (params) => {
            return params.row.pt_type === "CLASS" ? "클래스쿠폰" : "패스쿠폰";
        },
    },
    {
        field: "item",
        headerName: "상품명",
        width: 160,
        renderCell: (params) => {
            return params.row.pname;
        },
    },
    { field: "total_amount", headerName: "금액", align: "center", width: 100 },
    { field: "total_count", headerName: "보유", align: "center", width: 70 },
    { field: "use_count", headerName: "사용", align: "center", width: 70 },
    {
        field: "term",
        headerName: "유효기간",
        width: 200,
        align: "center",
        renderCell: (params) => {
            return (
                <>
                    {moment(params.row.enroll_sdate).format("YYYY.MM.DD")} -{" "}
                    {moment(params.row.enroll_edate).format("YYYY.MM.DD")}
                </>
            );
        },
    },
    {
        field: "state",
        headerName: "상태",
        width: 90,
        align: "center",
        renderCell: (params) => {
            const color = params.row.state === "Y" ? "#3096F4" : "gray";
            return <LightbulbIcon sx={{ color: color }}></LightbulbIcon>;
        },
    },
];


function ReturnFindCoupon(props) {

    const { openFindCoupon, setOpenFindCoupon, login, setCoupon } = props;
    const token = get_token();
    const load_data = async () => {
        let result = await axios.post(configState.api + "/gympass_admin/coupon", {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            tcid: "CID00000009",
            sname: sname,
            sphone: sphone,
        });
        setRows(result.data.rows);
    };
    const [rows, setRows] = useState([]);
    const [sname, setSname] = useState(''); // search
    const [sphone, setSphone] = useState(''); // search

    const onConfirm = (params) => {
        let { id, mb_name, pname, regdate, mcd } = params.row;
        regdate = moment(regdate).format("YYYY.MM.DD");
    
        Swal.fire({
            html: `[${regdate}] [${mb_name}] [${pname}] - 선택 하시겠습니까?`,
            title: "쿠폰선택",
            showConfirmButton: true,
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                setCoupon({
                    name:pname + ' (' + mb_name + ')',
                    seq:id,
                    mcd: mcd,
                })
                setOpenFindCoupon(false);
            }
        });
    };    

    useEffect(() => {
        if (openFindCoupon) {
            load_data();
        }
    }, [openFindCoupon]);

    return <Dialog
        open={openFindCoupon}
        fullWidth={true}
        maxWidth="md"
        TransitionComponent={Transition}
        onClose={() => setOpenFindCoupon(false)}
    >
        <AppBar sx={{ position: "static" }}>
            <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                    <Typography style={{ fontSize: 18 }}>쿠폰찾기</Typography>
                </Box>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={() => setOpenFindCoupon(false)}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
            </Toolbar>
        </AppBar>

        <Box display="flex" sx={{ p: 1 }}>
            <Box>
                <TextField
                    sx={{ width: 120 }}
                    name="sname"
                    label="이름"
                    size="small"
                    onChange={(e) => setSname(e.target.value)}
                    autoComplete="off"
                    value={sname}
                ></TextField>
            </Box>
            <Box sx={{ ml: 1 }}>
                <TextField
                    sx={{ width: 180 }}
                    name="sphone"
                    label="연락처"
                    size="small"
                    onChange={(e) => setSphone(e.target.value)}
                    autoComplete="off"
                    value={sphone}
                ></TextField>
            </Box>
            <Box sx={{ ml: 1 }}>
                <Button variant="contained" size="medium" onClick={() => load_data()}>
                    찾기
                </Button>
            </Box>
        </Box>

        <Box sx={{ p: 1 }}>
            <DataGrid sx={{ minHeight: 600 }}
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[5]}
                checkboxSelection={false}
                onRowClick={(params) => {
                    onConfirm(params);
                }}
            />
        </Box>
    </Dialog>
}

export default ReturnFindCoupon;